<template src="./user.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import { required, sameAs, minLength } from "vuelidate/lib/validators";
  import Endpoints from "@/config/ApiEndpoints.js";

  export default {
    components: {},
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "N/A";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },
    },
    data() {
      return {
        Users: [],
        FleetSubscriptionModules: [],
        submitted: false,
        Saving: false,
        SearchLoader: false,
        FleetSubscription: {},
        ShowAddUser: false,
        ShowReset2FA: false,
        basic: {
          currentPage: 1,
          totalPages: 0,
        },
        filter: {
          currentPage: 1,
          totalPages: 0,
        },
        filters: {
          name: {
            value: "",
            keys: ["forename", "surname", "email", "user_role", "phone"],
          },
        },
        ChangePassword: {
          id: 0,
          new_password: "",
          confirm_new_password: "",
        },
        ShowChangePassword: false,
      };
    },
    validations: {
      ChangePassword: {
        new_password: { required, minLength: minLength(8), // Minimum length of 8 characters
          // You can add additional validation rules for password strength
          strong: (value) => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])/.test(value),
        },
        confirm_new_password: {
          required,
          sameAsPassword: sameAs("new_password"),
        },
      },
    },
    mounted() {
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );

      this.FleetSubscription = FleetSubscription;

      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      var AccountRoles = JSON.parse(localStorage.getItem("permissions"));
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        AccountRoles.fleet_role_id != 1
      ) {
        this.$router.push("/");
      }

      document.title = pbx_SiteTitle + " - Users";
      this.FleetSubscriptionModules = FleetSubscriptionModules;
      this.GetUsers();
    },

    methods: {
      ChangePasswordData(RowID) {
        this.ChangePassword.id = RowID;
        this.ShowChangePassword = true;
      },
      GetUsers() {
        this.SearchLoader = true;
        var branchIDs = "";
        if (
          JSON.parse(localStorage.getItem("permissions")) &&
          typeof JSON.parse(localStorage.getItem("permissions")).branch_ids !=
            "undefined"
        ) {
          branchIDs = JSON.parse(
            localStorage.getItem("permissions")
          ).branch_ids;
        }
        var obj = {
          token: localStorage.getItem("token"),
          branchIDs: branchIDs,
        };
        this.ShowLoader = true;
        Axios.post(Endpoints.User.AllUser, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response.data.success) {
            this.SearchLoader = false;
            this.Users = Response.data.users;
            if (this.FleetSubscription.max_fleet_users > this.Users.length) {
              this.ShowAddUser = true;
            }
          }
        });
      },
      AddUser() {
        if (this.ShowAddUser) {
          this.$router.push("/add-user");
        } else {
          this.$swal(
            "You have reached your subscription's maximum allowed users. Please contact us to add more users",
            "",
            "error"
          );
        }
      },
      DeleteUser(id) {
        this.$swal({
          title: "Are you sure You want to delete?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Deleting...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.User.Delete, {
              token: localStorage.getItem("token"),
              id: id,
            }).then((Response) => {
              if (Response.data.success === true) {
                this.$swal.close();
                this.GetUsers();
                this.$swal
                  .fire("User Deleted Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response.data.message, "", "error")
                  .then(() => {});
              }
            });
          }
        });
      },
      Reset2F(id) {
        this.$swal({
          title: "Are you sure You want to reset 2FA?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, reset it!",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Processing...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.User.Reset2FA, {
              token: localStorage.getItem("token"),
              id: id,
            }).then((Response) => {
              if (Response.data.success === true) {
                this.$swal.close();
                this.GetUsers();
                this.$swal
                  .fire("User 2FA Reset Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response.data.message, "", "error")
                  .then(() => {});
              }
            });
          }
        });
      },
      changePassword() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.Saving = true;
        Axios.post(Endpoints.User.Password.Update, {
          token: localStorage.getItem("token"),
          ...this.ChangePassword,
        }).then((Response) => {
          this.Saving = false;
          if (Response.data.success) {
            this.$swal
              .fire("Password has been Updated Successfully", "", "success")
              .then(() => {
                this.ShowChangePassword = false;
                this.ChangePassword.id = 0;
                this.ChangePassword.new_password = "";
                this.ChangePassword.confirm_new_password = "";
                this.Saving = false;
                this.submitted = false;
              });
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
      showPassword: function (id) {
        if ($("#" + id).attr("type") === "password") {
          $("#" + id).attr("type", "text");
          $("#" + id + "Box span").removeClass("show");
        } else {
          $("#" + id).attr("type", "password");
          $("#" + id + "Box span").addClass("show");
        }
      },
    },
  };
</script>
<style scoped>
  .UsersBody td {
    padding-left: 15px !important;
  }
  .UsersBody .btn-primary {
    border: 1px solid transparent !important;
  }
  .table thead th,
  .table th,
  .table td {
    border: 0 !important;
  }
  .btn-dark.flat {
      padding: 4px 12px !important;
  }
  @media (min-width: 1280px) and (max-width: 1680px) {
    .actionBTN {
      width: 25%;
    }
  }
  @media (min-width: 780px) and (max-width: 1370px) {
    .actionBTN {
      min-width: 190px;
    }
  }
</style>
